module.exports = __webpack_public_path__ + "img/hard-hat-solid.159df224.svg";